import { useHistory } from 'react-router-dom';
import { clearAuthToken } from '../auth';
import { CogIcon, CurrencyDollarIcon, LogoutIcon, UserIcon } from '@heroicons/react/outline';
import { Popover } from '@headlessui/react'
import Avatar from './Avatar';
import UsagePanel from './UsagePanel';
import GuidesButton from './GuidesButton';
import useUser from '../hooks/useUser';

function User() {
  const history = useHistory();

  const { user } = useUser();

  const showProfileMessage = !user?.profile.jobTitle;
  const showSubscriptionMessage = user?.subscription?.tier === "trial";

  function handleSignOut() {
    clearAuthToken();

    // @ts-ignore
    const google = window.google;
    google.accounts.id.disableAutoSelect();

    window.location.reload();
  }

  if (!user)
    return null;

  return (
    <div className='flex items-center h-full mr-8 gap-4'>
      <GuidesButton />

      <UsagePanel className="w-72" />

      <Popover className="relative h-full flex items-center gap-1">

        <Popover.Button className="outline-none">
          <Avatar url={user.avatar} className="w-10 h-10" />
          {showProfileMessage &&
            <div className='absolute bg-yellow text-white flex items-center justify-center border-white border-2 shadow rounded-full w-4 h-4 -right-1 -top-1' />
          }
          {!showProfileMessage && showSubscriptionMessage &&
            <div className='absolute bg-blue text-white flex items-center justify-center border-white border-2 shadow rounded-full w-4 h-4 -right-1 -top-1' />
          }
        </Popover.Button>

        <Popover.Panel className="absolute right-0 top-12 flex flex-col w-64 bg-white text-gray-600 shadow rounded text-sm z-40">
          <div className='font-gilroy font-semibold p-4'>
            {user.email}
          </div>

          <hr className='mx-4 my-1' />

          <Popover.Button className='flex flex-col hover:bg-blue-50 cursor-pointer p-4' onClick={() => history.push("/settings")}>
            <div className='flex items-center gap-2 font-gilroy'>
              <UserIcon className='w-4 h-4' />
              Profile
            </div>
            {showProfileMessage &&
              <div className='text-xs font-semibold text-yellow text-left mt-2 -mb-2'>
                Your profile is not yet complete
              </div>
            }
          </Popover.Button>

          <Popover.Button className='flex flex-col hover:bg-blue-50 cursor-pointer p-4' onClick={() => history.push("/settings/billing")}>
            <div className='flex items-center gap-2 font-gilroy'>
              <CurrencyDollarIcon className='w-4 h-4' />
              Subscription
            </div>
            {showSubscriptionMessage &&
              <div className='text-xs font-semibold text-blue text-left mt-2 -mb-2'>
                You are currently on a trial of Pro
              </div>
            }
          </Popover.Button>

          <Popover.Button className='flex items-center gap-2 hover:bg-blue-50 cursor-pointer p-4 font-gilroy' onClick={() => history.push("/settings")}>
            <CogIcon className='w-4 h-4' />
            Settings
          </Popover.Button>

          <Popover.Button className='flex items-center gap-2 hover:bg-blue-50 cursor-pointer p-4 font-gilroy' onClick={handleSignOut}>
            <LogoutIcon className='w-4 h-4' />
            Sign Out
          </Popover.Button>

        </Popover.Panel>

      </Popover>
    </div>
  );
}

export default User;
